import { useRef } from "react";
import { useInputEditor } from "src/components/useInputEditor";
import { useTinyMce } from "src/components/useTinyMce";
import styles from "./styles.module.scss";
import cx from "classnames";

type RenderType = "inputPlaceholder" | "buttonText";

interface GatingCustomization {
  headerText: string;
  descriptionText: string;
  buttonText: string;
  inputPlaceholderText: string;
}

// parent renders (header, description, button, inputPlaceholder) 
export const useGatingCustomization = ({ headerText, descriptionText, buttonText, inputPlaceholderText}: GatingCustomization) => {
  const header = useGatingCustomizationTinyMce({value: headerText}); // tinymce
  const description = useGatingCustomizationTinyMce({value: descriptionText}); // tinymce
  const button = useGatingCustomizationInput({ // inputEditor
    value: buttonText,
    viewerType: "buttonText",
  });
  const inputPlaceholder = useGatingCustomizationInput({ // inputEditor
    value: inputPlaceholderText,
    viewerType: "inputPlaceholder",
  });

  return {
    header,
    description,
    button,
    inputPlaceholder,
  };
};

// inputEditor Hook
export function useGatingCustomizationInput({value, viewerType}: {value: string, viewerType: RenderType}) {
   const values = useRef(value)
   return useInputEditor(values.current, viewerType);
}
// tinyMce Hook
export function useGatingCustomizationTinyMce({value}: {value: string}) {
   const values = useRef(value)
   return useTinyMce(values.current);
}

// Viewer
export const GatingCustomizationViewer = ({ HeaderText, Description ,ButtonText, InputPlaceHolderText, buttonColor, buttonTextColor }) => (
  <div className={styles.viewerContainer}>
    <div className={styles.innerContainer}>
      <div className={styles.header}>
        <HeaderText/>
      </div>
      <div className={styles.subContainer}>
        <div className={styles.description}>
            <Description />
        </div>
          <InputPlaceHolderText />
      </div>
    </div>
    <ButtonText inlineStyles={{ backgroundColor: buttonColor, color: buttonTextColor }} />
 </div>
);

// Editor
export const GatingCustomizationEditor = ({  HeaderText, Description , ButtonText, InputPlaceHolderText }) => (
  <div className={styles.editorContainer}>
    <div className={styles.header}>
       <h5 className={styles.title}>Gating Customization</h5>
       <p className={styles.subText}>Customise how you would want to collect email from your anonymous users when you gate the collection.</p>
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Header Text</p>
      <HeaderText 
        classnames={cx(styles.tinyMce, styles.headerContainer)} 
        plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputContainer}>
      <p className={styles.label}>Description Text</p>
      <Description
         classnames={cx(styles.tinyMce, styles.descriptionContainer)}
         plugins = 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste'
        toolbar = 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link'
        quickToolbar={true}
        transparentBackground={true}
      />
    </div>
    <div className={styles.inputGroup}>
      <div className={styles.inputContainer}>
         <p className={styles.label}>Button Text</p>
         <ButtonText maxLength={20} />
      </div>
       <div className={styles.inputContainer}>
         <p className={styles.label}>Placeholder Text</p>
         <InputPlaceHolderText maxLength={20} />
      </div>
    </div>
 </div>
);
